import { connect } from 'react-redux';
import { ProfileMeta, PortfolioMeta }from 'profile/components/meta';
import mapProfileToProps from 'profile/containers/map_profile_to_props';

var ProfileMetaContainer = connect(mapProfileToProps)(ProfileMeta);
var PortfolioMetaContainer = connect(mapProfileToProps)(PortfolioMeta);

export { ProfileMetaContainer as ProfileMeta, PortfolioMetaContainer as PortfolioMeta }



// WEBPACK FOOTER //
// ./profile/containers/meta.js